export default "__VITE_ASSET__DwTUWSPD__"